"use strict";var e=require("react"),t=require("@swiggy-private/dls-web-core/dist/components/Text"),r=require("@swiggy-private/dls-web-icons/dist/GenericIconWeb"),a=require("@swiggy-private/dls-web-icons/dist/web/generic/plus/12"),i=require("styled-components");function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var l=n(e),o=n(a),s=n(i);const d=i.css`
    background: transparent;
    border: none;
    outline: none;
    padding: 0;
    text-align: left;
    appearance: none;
`,m=s.default.button`
    ${d}
    ${e=>e.theme.typography["V2.body2.neutral.medium"]}
    background: ${e=>e.theme.colors.light.background_Primary};
    border: 1px solid ${e=>e.theme.colors.light.divider};
    border-radius: ${e=>e.theme.spacing.xSmall};
    color: ${e=>e.theme.colors.light.text_Med_Emphasis};
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: ${e=>e.theme.spacing.xSmall} ${e=>e.theme.spacing.small}
        ${e=>e.theme.spacing.xSmall} ${e=>e.theme.spacing.xSmall};
`,c=s.default("span")`
    margin-right: 6px;
    margin-bottom: ${e=>e.theme.spacing.xxxSmall};
    position: relative;
`,p=s.default.div`
    margin-top: 1px;
`;var u=e.memo((({onClick:e})=>l.default.createElement(m,{onClick:e},l.default.createElement(c,{as:"span"},l.default.createElement(r.GenericIcon,{Icon:o.default,strokeColor:"text_Med_Emphasis",fillColor:"text_Med_Emphasis"})),l.default.createElement(p,null,l.default.createElement(t.Text,{color:"text_Med_Emphasis",variant:"V2.body3.neutral.medium"},"Add more items")))));exports.AddMoreItems=u;
//# sourceMappingURL=AddMoreItems-yJH7iMAZ.js.map
